export const PRIMARY_COLOR = '#03a54f';
export const PRIMARY_COLOR_DARK = '#2e7d32';
export const SECONDARY_COLOR = '#0E0E0E';

export const SUCCESS_COLOR = '#27AE60';
export const WARNING_COLOR = '#D3AE05';
export const ERROR_COLOR = '#F74343';
export const INFO_COLOR = '#12a4ed';

export const BLACK_COLOR = '#000000';
export const GREY_COLOR = '#ACACAC';
export const WHITE_COLOR = '#FFFFFF';
